module.exports = __webpack_public_path__ + "static/media/1.30abe425.jpg";